export interface SalesInvoiceItems {
  id: string;
  salesInvoiceHeaderId: string;
  salesOrderAndLineNo: string;
  quantity: number;
  price: number;
  value: number;
  notes: string;
}
